import { AUTH_AND_INITIALIZE } from '@/data/url'
import apiClient from '@/services/apiClient'

const initialize = async () => {
    try {
        const response = await apiClient.post(AUTH_AND_INITIALIZE)
        const data = response.data

        if (!data.user) {
            return null
        }

        // Normalize the response so consumers can keep using the old shape.
        return {
            ...data,
            dropdowns: data.dropdowns || data.user.dropdowns || {},
            search_parts_permissions:
                data.search_parts_permissions || data.user.search_parts_permissions || [],
            session_expiry: data.session_expiry || data.user.session_expiry || '',
        }
    } catch (e) {
        console.error('Error:', e.message)
        return null
    }
}

export default {
    initialize,
}
